// This file is automatically generated. Do not edit manually.

import { ConfigurationPropertyValues } from "src/api/generated/erp/configurator/model/configurationPropertyValues";
import { ObjectConfigurationHistoryEntryInput } from "src/api/generated/erp/configurator/objectConfigurationHistory/objectConfigurationHistoryEntryInput";
import { UnsavedCustomerOrderLinePartConfiguratorType } from "src/api/generated/erp/configurator/configuratorType/impl/unsavedCustomerOrderLinePartConfiguratorType";
import { UnsavedCustomerOfferLinePartConfiguratorType } from "src/api/generated/erp/configurator/configuratorType/impl/unsavedCustomerOfferLinePartConfiguratorType";
import { UnsavedShopOrderPartConfiguratorType } from "src/api/generated/erp/configurator/configuratorType/impl/unsavedShopOrderPartConfiguratorType";
import { ConfigurationManualEditContext } from "src/api/generated/erp/configurator/manualEdit/configurationManualEditContext";
import { makeAxiosRequest } from "src/api/utils/apiClient";

export namespace ConfigurationCreationApi {
	export async function createPartConfigurationForCustomerOrderLine(args: {
		customerOrderLineId: number;
		configurationSessionId: string;
		propertyValues?: ConfigurationPropertyValues | null | undefined;
		historyEntryInput: ObjectConfigurationHistoryEntryInput;
		testContextEnabled?: boolean;
		propertyInputValues?: Record<string, unknown | null | undefined> | null | undefined;
	}): Promise<number> {
		const response = await makeAxiosRequest({
			url: "/api/ext/erp/configurator/createPartConfigurationForCustomerOrderLine",
			method: "POST",
			data: {
				customerOrderLineId: args.customerOrderLineId,
				configurationSessionId: args.configurationSessionId,
				propertyValues: args.propertyValues,
				historyEntryInput: args.historyEntryInput,
				testContextEnabled: args.testContextEnabled,
				propertyInputValues: args.propertyInputValues,
			},
		});
		return response as number;
	}

	export async function createPartConfigurationForUnsavedCustomerOrderLine(args: {
		configuratorType: UnsavedCustomerOrderLinePartConfiguratorType;
		configurationSessionId: string;
		propertyValues?: ConfigurationPropertyValues | null | undefined;
		propertyInputValues?: Record<string, unknown | null | undefined> | null | undefined;
	}): Promise<number> {
		const response = await makeAxiosRequest({
			url: "/api/ext/erp/configurator/createPartConfigurationForUnsavedCustomerOrderLine",
			method: "POST",
			data: {
				configuratorType: args.configuratorType,
				configurationSessionId: args.configurationSessionId,
				propertyValues: args.propertyValues,
				propertyInputValues: args.propertyInputValues,
			},
		});
		return response as number;
	}

	export async function createPartConfigurationForCustomerOrderOfferLine(args: {
		customerOrderOfferLineId: number;
		configurationSessionId: string;
		propertyValues?: ConfigurationPropertyValues | null | undefined;
		historyEntryInput?: ObjectConfigurationHistoryEntryInput;
		testContextEnabled?: boolean;
		propertyInputValues?: Record<string, unknown | null | undefined> | null | undefined;
	}): Promise<number> {
		const response = await makeAxiosRequest({
			url: "/api/ext/erp/configurator/createPartConfigurationForCustomerOrderOfferLine",
			method: "POST",
			data: {
				customerOrderOfferLineId: args.customerOrderOfferLineId,
				configurationSessionId: args.configurationSessionId,
				propertyValues: args.propertyValues,
				historyEntryInput: args.historyEntryInput,
				testContextEnabled: args.testContextEnabled,
				propertyInputValues: args.propertyInputValues,
			},
		});
		return response as number;
	}

	export async function createPartConfigurationForAcceptedCustomerOfferLine(args: {
		customerOrderOfferLineId: number;
		configurationSessionId: string;
		propertyValues?: ConfigurationPropertyValues | null | undefined;
		testContextEnabled?: boolean;
		propertyInputValues?: Record<string, unknown | null | undefined> | null | undefined;
	}): Promise<ConfigurationCreationApi_AcceptedCustomerOfferLineConfiguration> {
		const response = await makeAxiosRequest({
			url: "/api/ext/erp/configurator/createPartConfigurationForAcceptedCustomerOfferLine",
			method: "POST",
			data: {
				customerOrderOfferLineId: args.customerOrderOfferLineId,
				configurationSessionId: args.configurationSessionId,
				propertyValues: args.propertyValues,
				testContextEnabled: args.testContextEnabled,
				propertyInputValues: args.propertyInputValues,
			},
		});
		return response as ConfigurationCreationApi_AcceptedCustomerOfferLineConfiguration;
	}

	export async function setAcceptedCustomerOfferLinePartConfiguration(args: {
		customerOrderOfferLineId: number;
		partConfigurationId: number;
		historyEntryInput: ObjectConfigurationHistoryEntryInput;
		orderChangeSubject: string;
		orderChangeContent: string;
	}): Promise<number> {
		const response = await makeAxiosRequest({
			url: "/api/ext/erp/configurator/setAcceptedCustomerOfferLinePartConfiguration",
			method: "POST",
			data: {
				customerOrderOfferLineId: args.customerOrderOfferLineId,
				partConfigurationId: args.partConfigurationId,
				historyEntryInput: args.historyEntryInput,
				orderChangeSubject: args.orderChangeSubject,
				orderChangeContent: args.orderChangeContent,
			},
		});
		return response as number;
	}

	export async function createPartConfigurationForUnsavedCustomerOfferLine(args: {
		configuratorType: UnsavedCustomerOfferLinePartConfiguratorType;
		configurationSessionId: string;
		propertyValues?: ConfigurationPropertyValues | null | undefined;
		propertyInputValues?: Record<string, unknown | null | undefined> | null | undefined;
	}): Promise<number> {
		const response = await makeAxiosRequest({
			url: "/api/ext/erp/configurator/createPartConfigurationForUnsavedCustomerOfferLine",
			method: "POST",
			data: {
				configuratorType: args.configuratorType,
				configurationSessionId: args.configurationSessionId,
				propertyValues: args.propertyValues,
				propertyInputValues: args.propertyInputValues,
			},
		});
		return response as number;
	}

	export async function createPartConfigurationForShopOrderLine(args: {
		shopOrderLineId: number;
		configurationSessionId: string;
		propertyValues?: ConfigurationPropertyValues | null | undefined;
		historyEntryInput?: ObjectConfigurationHistoryEntryInput;
		propertyInputValues?: Record<string, unknown | null | undefined> | null | undefined;
	}): Promise<number> {
		const response = await makeAxiosRequest({
			url: "/api/ext/erp/configurator/createPartConfigurationForShopOrderLine",
			method: "POST",
			data: {
				shopOrderLineId: args.shopOrderLineId,
				configurationSessionId: args.configurationSessionId,
				propertyValues: args.propertyValues,
				historyEntryInput: args.historyEntryInput,
				propertyInputValues: args.propertyInputValues,
			},
		});
		return response as number;
	}

	export async function createPartConfigurationForShopOrder(args: {
		shopOrderId: number;
		configurationSessionId: string;
		propertyValues?: ConfigurationPropertyValues | null | undefined;
		historyEntryInput?: ObjectConfigurationHistoryEntryInput;
		propertyInputValues?: Record<string, unknown | null | undefined> | null | undefined;
	}): Promise<number> {
		const response = await makeAxiosRequest({
			url: "/api/ext/erp/configurator/createPartConfigurationForShopOrder",
			method: "POST",
			data: {
				shopOrderId: args.shopOrderId,
				configurationSessionId: args.configurationSessionId,
				propertyValues: args.propertyValues,
				historyEntryInput: args.historyEntryInput,
				propertyInputValues: args.propertyInputValues,
			},
		});
		return response as number;
	}

	export async function createPartConfigurationForUnsavedShopOrder(args: {
		configuratorType: UnsavedShopOrderPartConfiguratorType;
		configurationSessionId: string;
		propertyValues?: ConfigurationPropertyValues | null | undefined;
		propertyInputValues?: Record<string, unknown | null | undefined> | null | undefined;
	}): Promise<number> {
		const response = await makeAxiosRequest({
			url: "/api/ext/erp/configurator/createPartConfigurationForUnsavedShopOrder",
			method: "POST",
			data: {
				configuratorType: args.configuratorType,
				configurationSessionId: args.configurationSessionId,
				propertyValues: args.propertyValues,
				propertyInputValues: args.propertyInputValues,
			},
		});
		return response as number;
	}

	export async function createPartConfigurationForPurchaseOrderLine(args: {
		purchaseOrderLineId: number;
		configurationSessionId: string;
		propertyValues?: ConfigurationPropertyValues | null | undefined;
		historyEntryInput?: ObjectConfigurationHistoryEntryInput;
		propertyInputValues?: Record<string, unknown | null | undefined> | null | undefined;
	}): Promise<number> {
		const response = await makeAxiosRequest({
			url: "/api/ext/erp/configurator/createPartConfigurationForPurchaseOrderLine",
			method: "POST",
			data: {
				purchaseOrderLineId: args.purchaseOrderLineId,
				configurationSessionId: args.configurationSessionId,
				propertyValues: args.propertyValues,
				historyEntryInput: args.historyEntryInput,
				propertyInputValues: args.propertyInputValues,
			},
		});
		return response as number;
	}

	export async function createPartConfigurationForProjectActivityMaterial(args: {
		activityMaterialLineId: number;
		configurationSessionId: string;
		propertyValues?: ConfigurationPropertyValues | null | undefined;
		historyEntryInput?: ObjectConfigurationHistoryEntryInput;
		propertyInputValues?: Record<string, unknown | null | undefined> | null | undefined;
	}): Promise<number> {
		const response = await makeAxiosRequest({
			url: "/api/ext/erp/configurator/createPartConfigurationForProjectActivityMaterial",
			method: "POST",
			data: {
				activityMaterialLineId: args.activityMaterialLineId,
				configurationSessionId: args.configurationSessionId,
				propertyValues: args.propertyValues,
				historyEntryInput: args.historyEntryInput,
				propertyInputValues: args.propertyInputValues,
			},
		});
		return response as number;
	}

	export async function createPartConfigurationForBomLine(args: {
		partConfigurationBomLineId: number;
		configurationSessionId: string;
		propertyValues?: ConfigurationPropertyValues | null | undefined;
		manualEditContext?: ConfigurationManualEditContext | null | undefined;
		propertyInputValues?: Record<string, unknown | null | undefined> | null | undefined;
	}): Promise<number> {
		const response = await makeAxiosRequest({
			url: "/api/ext/erp/configurator/createPartConfigurationForBomLine",
			method: "POST",
			data: {
				partConfigurationBomLineId: args.partConfigurationBomLineId,
				configurationSessionId: args.configurationSessionId,
				propertyValues: args.propertyValues,
				manualEditContext: args.manualEditContext,
				propertyInputValues: args.propertyInputValues,
			},
		});
		return response as number;
	}
}

export interface ConfigurationCreationApi_AcceptedCustomerOfferLineConfiguration {
	costChange: number;
	partConfigurationId: number;
	priceChange: number;
}
